import {
  Component, OnInit
} from '@angular/core';
import { DialogComponent } from "../dialog/dialog.component";
import { DialogService } from "../dialog";
export interface ConfirmMode29 {
  title: string;
  Items: any;
  SupId: any;
}
@Component({
  selector: 'app-chqprint',
  templateUrl: './chqprint.component.html',
  styleUrls: ['./chqprint.component.css']
})

export class ChqprintComponent extends DialogComponent<ConfirmMode29, boolean>
  implements OnInit {

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  language: string = "en-us";
  width: number = 75;
  height: number = 75;
  toolbar: string = "true";
  title: string;
  Items: any;
  SupId: any;
  ngOnInit() {
    this.width = 100
    this.title = this.title;
    this.Items = this.Items;
    this.SupId = this.SupId
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/chqprint/chqprint.component.ts